export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14733.e1fcdb41.jpg";